// /events/:eventId/stock — kept as a redirect. The stock page became the
// Stok tab of the event detail page; old links and bookmarks still land there.

import { Navigate, useParams } from 'react-router-dom';

export default function EventStock() {
  const { eventId } = useParams<{ eventId: string }>();
  return <Navigate to={`/events/${eventId}?tab=stok`} replace />;
}
